import { render, staticRenderFns } from "./CrmPageHeader.vue?vue&type=template&id=23b18b07&scoped=true"
import script from "./CrmPageHeader.vue?vue&type=script&lang=js"
export * from "./CrmPageHeader.vue?vue&type=script&lang=js"
import style0 from "./CrmPageHeader.vue?vue&type=style&index=0&id=23b18b07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b18b07",
  null
  
)

export default component.exports